// extracted by mini-css-extract-plugin
var _1 = "ra-menu-switch-animated";
var _2 = "ra-menu-switch";
var _3 = "ra-menu-switch-drawer";
var _4 = "ra-menu-switch-label";
var _5 = "ra-menu-switch-label-static";
var _6 = "ra-menu-switch-label-value";
var _7 = "ra-menu-switch-list";
var _8 = "ra-menu-switch-opened";
var _9 = "ra-menu-switch-selected";
export { _1 as "menuSwitchAnimatedCls", _2 as "menuSwitchCls", _3 as "menuSwitchDrawerCls", _4 as "menuSwitchLabelCls", _5 as "menuSwitchLabelStaticCls", _6 as "menuSwitchLabelValueCls", _7 as "menuSwitchListCls", _8 as "menuSwitchOpenedCls", _9 as "menuSwitchSelectedCls" }
